"use client";

import type { ElementType } from "react";
import DOMPurify from "@/app/[lang]/utils/dompurify";
import { useRewrittenHtml } from "./useRewrittenHtml";

interface RichHtmlProps {
    html: string;
    className?: string;
    /** Rendered HTML tag (default: div). Useful for headings (h1, h2...). */
    as?: keyof JSX.IntrinsicElements;
    /** Sanitize the HTML with DOMPurify after rewriting the URLs. */
    sanitize?: boolean;
}

/**
 * Renders Strapi HTML with its S3 URLs fixed: images (`src`) and PDF links
 * (`href`) are both mapped to CloudFront during render - a plain string replace,
 * no signing round-trip, nothing to re-check on click.
 */
export default function RichHtml({ html, className, as = "div", sanitize = false }: RichHtmlProps) {
    const content = useRewrittenHtml(html);
    const finalHtml = sanitize ? DOMPurify.sanitize(content) : content;
    const Tag = as as ElementType;

    return (
        <Tag
            className={className}
            dangerouslySetInnerHTML={{ __html: finalHtml }}
        />
    );
}
